import Vue from "vue";
import MyVuetable from '@/_oad_repo/components/table/Table-MyVuetable'
import TableActionBtns from '@/_oad_repo/components/table/Table-ActionBtns'
import TableSearch from '@/_oad_repo/components/table/Table-Search'
import TableFilters from '@/_oad_repo/components/table/Table-Filters'

Vue.component('my-vuetable',MyVuetable)
Vue.component('table-action-btns',TableActionBtns)
Vue.component('table-search',TableSearch)
Vue.component('table-filters',TableFilters) 